import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard
    isLocked
    to="/try-it-out/qmlativ/custom"
    image="/static/img/Card-SeeTheCode.png"
    imageAlt="Laptop with code"
    description="See the code"
    loggedOutDescription="Log in to See the Code"
  >
    Before you start programming, try out our code, get quick results, and modify your queries
  </FeatureCard>
);
